import type { LocalDatabasePriceList } from "../../../_Generated/Sync.gen";
import { SearchCommunicator } from "../../../Workers/Search/SearchCommunicator";
import { SearchIndexes } from "../../../Workers/Search/SearchEvents";
import type { BasePriceListRepository } from "../../_Bases/BasePriceListRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBPriceListRepository extends BaseIndexedDBRepository<
    LocalDatabasePriceList
> implements BasePriceListRepository {
    public readonly source: InternalIndexedDBDatabase["priceLists"];
    protected readonly dataTypeName = "Price List";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.priceLists;
    }

    public async search(value: string): Promise<Array<LocalDatabasePriceList>> {
        const needle = value.trim();

        if(!needle) {
            return this.all();
        }

        const ids = await SearchCommunicator.search(SearchIndexes.PRICE_LIST_NAME, needle);

        return this.source
            .where("uuid")
            .anyOf(ids)
            .sortBy("name");
    }

    private replaceIndexes(
        id: string,
        name?: string
    ): void {
        SearchCommunicator.updateIndex(SearchIndexes.PRICE_LIST_NAME, id, name);
    }

    private clearIndexes(): void {
        SearchCommunicator.emptyIndex(SearchIndexes.PRICE_LIST_NAME);
    }

    public put(item: Array<LocalDatabasePriceList> | LocalDatabasePriceList): Promise<string> {
        return super.put(item)
            .then(async id => {
                if(!Array.isArray(item)) {
                    item = [ item ];
                }

                for(let i = 0, l = item.length; i < l; i++) {
                    this.replaceIndexes(
                        item[i].uuid,
                        item[i].name
                    );
                }

                return id;
            });
    }

    public delete(item: Array<string> | string): Promise<void> {
        return super.delete(item)
            .then(() => {
                if(!Array.isArray(item)) {
                    item = [ item ];
                }

                for(let i = 0, l = item.length; i < l; i++) {
                    this.replaceIndexes(item[i]);
                }
            });
    }

    public empty(): Promise<void> {
        return super.empty()
            .then(() => {
                this.clearIndexes();
            });
    }
}
